﻿.suggested-agenda-items {

    .selection {
        width: 1%;
    }

    .title {
        width: 69%;
    }

    .meeting {
        width: 30%;
    }

}
